import React from 'react'
import { bool, string } from 'prop-types'
import IcoCheck from '../icons/IcoCheck'
import { SuccessBox, SuccessSeal } from './cancel-flow-styles'

export default function CancelSuccess( { fimVigencia, comEstorno } ) {
  const texto = ( () => {
    if ( comEstorno ) {
      return 'Agora é só aguardar o estorno.'
    }
    if ( fimVigencia ) {
      return <>Sua assinatura seguirá ativa até <b>{ fimVigencia }</b>, quando o seu plano vigente chegará ao fim.</>
    }
    return 'Sua assinatura seguirá ativa até o fim do seu plano vigente.'
  } )()

  return (
    <SuccessBox>
      <SuccessSeal $stop>
        <IcoCheck
          height="22"
          style={{ 'color': '#fff' }}
          width="22"
        />
      </SuccessSeal>
      <h2 className="serif">Renovação cancelada</h2>
      <p>{ texto }</p>
      <p>
        Sentiremos sua falta nessa viagem. A porta de embarque ficará aberta para
        quando quiser voltar.
      </p>
    </SuccessBox>
  )
}

CancelSuccess.propTypes = {
  'fimVigencia': string,
  'comEstorno': bool
}

CancelSuccess.defaultProps = {
  'fimVigencia': '',
  'comEstorno': false
}
